/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InternalDealTag {
    SUPPORT = 'SUPPORT',
    SALES_DEMO = 'SALES_DEMO',
    ONBOARDING = 'ONBOARDING',
    LIVE = 'LIVE',
    LEGACY = 'LEGACY',
}
